import { ConfigTextDefaults } from "../constants/config";
import { FormikProps } from "formik";
import { ILinjeKursistDTO } from "../config/form/linje/linjeKursistFormConfig";
import { AlertMessage } from "./AlertMessage";

export const MaxDeltagerWarningBox = ({
  type,
  antal,
}: {
  formik: FormikProps<ILinjeKursistDTO>;
  type: "kursus" | "linje";
  antal: number | undefined;
}) => {
  const deltagerMax = ConfigTextDefaults[type].DELTAGER_MAX;
  const lock = antal !== undefined && antal >= deltagerMax;
  if (!lock) {
    return null;
  }
  const name = type === "linje" ? "linjen" : "kurset";
  return (
    <AlertMessage
      type="primary"
      warningIcon
      heading={`${antal} personer er tilmeldt ${name}`}
    >
      <p className="mb-1">
        Der må som udgangspunkt maksimalt tilmeldes pt {deltagerMax} personer
        til {type === "linje" ? "en linje" : "et kursus"}
      </p>
    </AlertMessage>
  );
};
